import { useNavigate } from 'react-router-dom';

import { useHandlePaymentMethod } from './hooks/useHandlePaymentMethod';

import { Button, NavBar } from '@/components';
import { IconFigure } from '@/components/Icons';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import ROUTES from '@/router/routes';
import { TipoProductoTO } from '@/types/myAccount';

export const MobilePremiumBenefits = () => {
  const isMobile = useIsDesktop();
  const navigate = useNavigate();

  const content = (
    <div className="max-w-md mx-auto  p-6 rounded-lg text-gdt-gray-2">
      <div className="mb-6 bg-white rounded-lg p-4">
        <h2 className="flex items-center text-lg font-semibold text-gdt-blue mb-2">
          <div className="w-7 mr-1">
            <IconFigure />
          </div>
          Beneficios de ser Premium
        </h2>
        <ul className="list-disc ml-7 space-y-2 text-sm ">
          <li>
            Transferencias ilimitadas de cualquiera de tus equipos (Primera
            División y Fútbol 5) sin necesidad de ingresar pines.
          </li>
          <li>
            Si ganás la fecha en el torneo de Primera, multiplicás por 15 tu
            premio: ¡te llevás $1.500.000!
          </li>
          <li>
            Participás gratis en todas las competencias especiales del juego
            (excepto Torneos de Amigos por Premios y Fechas de Oro).
          </li>
          <li>
            Jugás automáticamente un Torneo de Amigos exclusivo con premios para
            los 5 mejores.
          </li>
          <li>
            Participás automáticamente de una Fecha Premium, con espectaculares
            $750.000 en premio para los 10 mejores.
          </li>
          <li>Contás con estadísticas exclusivas para mejorar tu equipo.</li>
        </ul>
      </div>

      <div className="mb-6 bg-white rounded-lg p-4">
        <h3 className="text-lg font-semibold mb-2 text-gdt-blue">
          ¿Qué es un Pack Premium?
        </h3>
        <p className="text-sm">
          <strong>El Pack Premium es una membresía </strong>que dura todo el
          Torneo de Gran DT y se abona por única vez. Al obtenerlo, te convertís
          en un DT Premium. Esto te permite acceder a diferentes beneficios:
          Tenés transferencias ilimitadas sin ingresar pines y si ganás la fecha
          de Primera, multiplicás por 15 tu premio: ¡te llevás $1.500.000!
        </p>
      </div>

      <div className="mb-6 bg-white rounded-lg p-4">
        <h3 className="text-lg font-semibold mb-2 text-gdt-blue">
          ¿Cómo obtengo el Pack Premium?
        </h3>
        <p className="text-sm">
          Para obtener el Pack Premium tenés que acceder a la{' '}
          <strong>sección Mis Pines</strong>, desde tu computadora o celular y
          seleccionar el Pack. Luego deberás elegir el medio de pago, abonar el
          costo y ya te convertirás en un DT Premium.
        </p>
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <NavBar
        desktop
        mobile={{
          leftContent: {
            backAction: () =>
              navigate(ROUTES.myAccount, {
                replace: true,
              }),
          },
          centerContent: {
            title: 'Pack Premium',
          },
        }}
      >
        {content}
      </NavBar>
    );
  }
  return <>{content}</>;
};

const Perk = ({ description }: { description: string }) => (
  <li className="flex  items-center">
    <div className="col-span-1">
      <div className="w-6">
        <IconFigure />
      </div>
    </div>
    <p className="col-span-11 text-gdt-gray-2 font-medium text-xs ml-4">
      {description}
    </p>
  </li>
);

interface PremiumCardProps {
  isPremium: boolean;
  product: TipoProductoTO | undefined;
  overrideAction?: () => void;
  isLastMatchDay: boolean;
}

export const DesktopPremiumPerks = ({
  isPremium,
  product,
  overrideAction,
  isLastMatchDay,
}: PremiumCardProps) => {
  const { handlePaymentMethod } = useHandlePaymentMethod();

  return (
    <div className="flex flex-col gap-y-6 mt-5 -mx-2">
      <Perk description="Participás automáticamente de una Fecha Premium, con espectaculares premios para los 10 mejores." />
      <Perk description="Participás gratis en todas las competencias especiales del juego (excepto Torneos de Amigos por Premios y Fechas de Oro)." />
      <Perk description="Contás con estadísticas exclusivas para mejorar tu equipo." />

      <div className="flex justify-center">
        <Button
          className="w-1/2 bg-gdt-status-yellow hover:shadow-btn-status border-0"
          disabled={isPremium || isLastMatchDay}
          type="button"
          variant="primary"
          onClick={() =>
            overrideAction ? overrideAction() : handlePaymentMethod({ product })
          }
        >
          Quiero ser Premium
        </Button>
      </div>
    </div>
  );
};
